export const device = {
  xs: '320px',
  sm: '575px',
  md: '768px',
  lg: '991px',
  xl: '1199px',
};
